import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AppConfigService } from '../services/config.service';
import { ConsoleService } from '../services/console.service';

@Injectable()
export class PreventDuplicateRequestInterceptor implements HttpInterceptor {
  //#region properties
  #lastRequest: string;
  #lastRequestBody: string;
  //#endregion

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const duplicatedPaths = [
      { path: '/Payments/GetDescriptorOnlineGateway', method: 'GET' },
      {
        path: '/ScheduledMessages/CreateScheduledMessageByPhonebook',
        method: 'POST',
      },
      { path: '/ScheduledMessages/Create', method: 'POST' },
      { path: '/Payments/ConfirmPayment', method: 'POST' },
      { path: '/Payments/RejectPayment', method: 'POST' },
      { path: '/ScheduledMessages/CreateFastScheduledMessage', method: 'POST' },
      {
        path: '/ScheduledMessages/CreateScheduledMessageBulk2',
        method: 'POST',
      },
      { path: '/ScheduledMessages/CreateScheduledMessageBulk', method: 'POST' },
      {
        path: '/ScheduledMessages/CreateDynamicScheduledMessage',
        method: 'POST',
      },
      {
        path: '/ScheduledMessages/CreateTrackingNumberP2PScheduledMessage',
        method: 'POST',
      },
      { path: '/ScheduledMessages/CreateP2PScheduledMessage', method: 'POST' },
      {
        path: '/ScheduledMessages/CreateFastPatternScheduledMessageByPhonebook',
        method: 'POST',
      },
      {
        path: '/ScheduledMessages/CreateRegionalScheduledMessage',
        method: 'POST',
      },
      { path: '/OccasionScheduledMessages/Create', method: 'POST' },
      {
        path: '/SmartSmsRecipients/CreatePeriodicSmartSmsRecipient',
        method: 'POST',
      },
      { path: '/SmartSmsRecipients/CreateSmartSmsRecipient', method: 'POST' },
      {
        path: '/SmartSmsRecipients/CreateP2PSmartSmsRecipients',
        method: 'POST',
      },
    ];

    const urlWithoutDomain = request.url.replace(
      AppConfigService.config.apiUrl,
      ''
    );
    //checks if current path exists in the list or not
    let currentPath = duplicatedPaths.find(
      (item) => item.path === urlWithoutDomain
    );

    // Check if the current request is the same as the previous one
    if (
      currentPath &&
      urlWithoutDomain === this.#lastRequest &&
      currentPath.method === request.method &&
      (JSON.stringify(this.#lastRequestBody) ===
        JSON.stringify(request?.body) ||
        this.#lastRequestBody === request?.body)
    ) {
      ConsoleService.info('Prevent duplicate request');
      return EMPTY;
    }

    // Update the last request path and body
    if (duplicatedPaths.some((item) => item.path === urlWithoutDomain)) {
      this.#lastRequest = urlWithoutDomain;
      this.#lastRequestBody = Object.assign({}, request?.body);
    }

    // Proceed with the request
    return next.handle(request);
  }
}

export const HttpPreventDuplicateRequestInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: PreventDuplicateRequestInterceptor,
    multi: true,
  },
];
